/*
Generated time: May 22, 2025 08:21
This file was created by the app developer. Feel free to contact the original developer with any questions. It was minified (compressed) by AVADA. AVADA do NOT own this script.
*/
var alignmentFns = {
  inputs: [],
  init: function (t, a, i, e, n) {
    var s = 90,
      r = this
    t.attr('readonly', 'readonly'),
      t.css('border', 'none'),
      t.css('width', 241),
      t.css('height', s),
      t.css('padding', '0px'),
      t.css('margin', '0px'),
      t.css('text-align', 'center'),
      t.css('vertical-align', 'middle'),
      t.css('line-height', '90px'),
      t.css('background-color', 'transparent'),
      t.wrap(
        "<div id = '" +
          t.attr('id') +
          "div' style = '  border-radius: 15px;overflow:hidden;display: flex;width:423px;height:" +
          s +
          "px;border: 4px solid rgba(0, 0, 0, .3);'></div>"
      ),
      t.before(
        "<div id = '" +
          t.attr('id') +
          "l'  onselectstart = 'return false;' style = 'font-size:56px;color: #000000;-moz-user-select:none;cursor:pointer;text-align:center;width:" +
          s +
          'px;height:' +
          s +
          'px;line-height:' +
          s +
          "px;float:left;;color:rgba(0, 0, 0, .3);'>—</div>"
      ),
      t.after(
        "<div id = '" +
          t.attr('id') +
          "r'  onselectstart = 'return false;' style = '-moz-user-select:none;cursor:pointer;text-align:center;font-size:56px;color:rgba(124, 124, 124, 1);width:" +
          s +
          'px;height:' +
          s +
          'px;line-height:' +
          s +
          "px;float:right;color:rgba(0, 0, 0, .3);'> + </div>"
      ),
      $('#' + t.attr('id') + 'l').click(function () {
        r.execute(t, a, i, e, n, !0)
      }),
      $('#' + t.attr('id') + 'r').click(function () {
        r.execute(t, a, i, e, n, !1)
      })
  },
  execute: function (t, a, i, e, n, s) {
    var r = parseFloat(this.format(t.val(), n))
    s && (r -= a), s || (r += a), r < e ? (r = e) : i < r && (r = i), t.val(this.format(r, n)).change()
  },
  format: function (t, a) {
    return isNaN(t) && (t = 0), parseFloat(t).toFixed(a)
  },
  data: { default_data: { step: 0.1, min: 0, max: 99, digit: 1 } },
  initialize: function () {
    var inputs = $(
      'input[user_data], input[data-digit], input[data-step], input[data-min], input[data-max], input.alignment'
    )
    inputs.each(function () {
      alignmentFns.inputs.push(this.outerHTML)
      var data = alignmentFns.data,
        user_data = eval('data.' + $(this).attr('user_data')),
        digit =
          (null == user_data && (user_data = JSON.parse(JSON.stringify(data.default_data))), $(this).data('digit')),
        step =
          (null == digit ||
            isNaN(parseFloat(digit)) ||
            ((digit = parseFloat(digit).toFixed(0)), (user_data.digit = parseFloat(digit))),
          $(this).data('step')),
        min = (null == step || isNaN(parseFloat(step)) || (user_data.step = parseFloat(step)), $(this).data('min')),
        max = (null == min || isNaN(parseFloat(min)) || (user_data.min = parseFloat(min)), $(this).data('max')),
        data_edit =
          (null == max || isNaN(parseFloat(max)) || (user_data.max = parseFloat(max)),
          alignmentFns.init($(this), user_data.step, user_data.max, user_data.min, user_data.digit),
          $(this).data('edit'))
      data_edit && $(this).attr('readonly', null)
    })
  },
  destroy: function () {
    var t = this.inputs
    $.each(t, function (t, a) {
      var a = $(a)[0],
        i = a.id
      $('#' + i + 'div').replaceWith(a)
    })
  },
  createType: function (t) {
    $.each(t, function (t, a) {
      alignmentFns.data[a.type] = a.data
    })
  }
}
